module.exports = __webpack_public_path__ + "img/auth.159bb4ac.webp";